import * as React from "react";
import { io } from "socket.io-client";
import {invalidateRealtimeEntity, reconcileRealtimeQueries} from "./query";

const REALTIME_EVENT = "data_changed";

export const socket = io(process.env.REACT_APP_API_URL, {
	autoConnect: false,
	auth: {
		token: null,
	},
});

let hasConnected = false;

function handleConnect() {
	if(hasConnected) reconcileRealtimeQueries();
	hasConnected = true;
}

function handleDataChanged(data) {
	if(!data || !data.entity) return;
	const fromCurrentSocket = data.sourceSocketId && data.sourceSocketId === socket.id;
	invalidateRealtimeEntity(data.entity, fromCurrentSocket ? {refetchActive: false, refetchInactive: false} : undefined);
}

function bindCoreListeners() {
	socket.off("connect", handleConnect);
	socket.off(REALTIME_EVENT, handleDataChanged);
	socket.on("connect", handleConnect);
	socket.on(REALTIME_EVENT, handleDataChanged);
}

export function disconnect() {
	socket.off("connect", handleConnect);
	socket.off(REALTIME_EVENT, handleDataChanged);
	socket.disconnect();
	hasConnected = false;
}

export function init(token) {
	disconnect();
	if(!token) return;

	socket.auth = {token};
	bindCoreListeners();
	socket.connect();
	window.socket = socket;
}

export function useSocket({name, onEvent}) {
	React.useEffect(() => {
		const handler = data => onEvent(data);
		socket.on(name, handler);
		return () => socket.off(name, handler);
	}, [name, onEvent]);
	return {socket};
}

export function emit(key, payload, onEmit) {
	socket.emit(key, ...payload, onEmit);
}

export default {socket, init, disconnect, useSocket};
